import {useParallax} from "react-scroll-parallax";

export function useParallaxEffect(bioType) {

  // Intro section
  const pitchSocialLanding = useParallax({
    opacity: [1, 0],
    startScroll: 0,
    endScroll: 500,
  });

  const introTitleWrapper = useParallax({
    opacity: [0, 1],
    startScroll: 0,
    endScroll: 500,
  })

  const introTitle = useParallax({
    opacity: [0, 1],
    startScroll: 1000,
    endScroll: 1800,
  });

  const introFigure = useParallax({
    opacity: [1, .2],
    scale: [1, 0.9],
    startScroll: 1000,
    endScroll: 1800,
  });

  const introPage = useParallax({
    startScroll: 0,
    endScroll: 1800,
  });

  // Explore section.
  const exploreTitle = useParallax({
    opacity: [0, 1],
    translateY: [100, 20],
    startScroll: 800,
    endScroll: 1200,
  });

  const exploreCards = useParallax({
    opacity: [0, 1],
    translateX: [100, 0],
    startScroll: 1000,
    endScroll: 1400,
  });

  const exploreDescription = useParallax({
    opacity: [0, 1],
    translateY: [100, -20],
    startScroll: 1300,
    endScroll: 1800,
  });

  const explorePage = useParallax({
    opacity: [1, 1],
    startScroll: 1000,
    endScroll: 2500,
    onProgressChange: (progress) => {
      const introFigureElement = introFigure.ref.current;
      const exploreTitleElement = exploreTitle.ref.current;
      const exploreDescriptionElement = exploreDescription.ref.current;
      const exploreCardsElement = exploreCards.ref.current;
      if (progress > 0.7) {
        const value = (1 - progress);
        const percent = value / 0.3;
        const opacityValue = percent;
        const translateYValue = ((-20 - 100) * percent) + 100;
        const rotateYValue = ((0 - 360) * percent) + 360;
        exploreTitleElement.style.opacity = opacityValue;
        exploreDescriptionElement.style.opacity = opacityValue;
        exploreDescriptionElement.style.transform = `translateY(${translateYValue}%)`;
        exploreCardsElement.style.transform = `scale(${opacityValue}) rotateY(${rotateYValue}deg)`;
        exploreCardsElement.style.opacity = opacityValue;
        introFigureElement.style.opacity = opacityValue;
      }
    }
  });

  // Profile section.
  const profileTitle = useParallax({
    opacity: [0, 1],
    translateY: [100, 20],
    startScroll: 2400,
    endScroll: 2600,
  });

  const profileFigure = useParallax({
    opacity: [0, 1],
    scale: [0.5, 1],
    startScroll: 2400,
    endScroll: 2600,
  });

  const profileInterest = useParallax({
    opacity: [0, 1],
    scale: [0.5, 1],
    translateX: [50, 0],
    startScroll: 2700,
    endScroll: 2800,
  });

  const profileDescription = useParallax({
    opacity: [0, 1],
    translateY: [100, -20],
    startScroll: 2700,
    endScroll: 2800,
  })

  const profilePage = useParallax({
    startScroll: 2300,
    endScroll: 3000,
    onProgressChange: (progress) => {
      const profileTitleElement = profileTitle.ref.current;
      const profileFigureElement = profileFigure.ref.current;
      const profileInterestElement = profileInterest.ref.current;
      const profileDescriptionElement = profileDescription.ref.current;
      if (progress > 0.6 && progress <= 0.8) {
        const percent = (progress - 0.6) / (0.8 - 0.6);
        const opacityValue = ((0.8 - 1) * percent) + 1;
        const scaleValue = ((0.95 - 1) * percent) + 1;
        const translateXValue = (-30 * percent);
        profileFigureElement.style.opacity = opacityValue;
        profileFigureElement.style.transform = `scale(${scaleValue}) translateX(${translateXValue}%)`;
      }
      if (progress > 0.95) {
        const percent = (progress - 0.95) / (1 - 0.95);
        const opacityValue = ((0 - 1) * percent) + 1;
        profileTitleElement.style.opacity = opacityValue;
        profileFigureElement.style.opacity = opacityValue;
        profileInterestElement.style.opacity = opacityValue;
        profileDescriptionElement.style.opacity = opacityValue;
      }
    }
  });

  // Make a plan section.
  const makePlanTitle = useParallax({
    opacity: [0, 1],
    translateY: [100, 20],
    startScroll: 2900,
    endScroll: 3200,
  });

  const makePlanFigure = useParallax({
    opacity: [0, 1],
    scale: [0.5, 1],
    startScroll: 3000,
    endScroll: 3300,
  });

  const makePlanCards = useParallax({
    opacity: [0, 1],
    translateX: [100, 0],
    startScroll: 3300,
    endScroll: 3500,
  });

  const makePlanDescription = useParallax({
    opacity: [0, 1],
    translateY: [100, -20],
    startScroll: 3400,
    endScroll: 3500,
  });

  const makePlanCardFadeOut1 = useParallax({
    opacity: [1, 0],
    startScroll: 3600,
    endScroll: 3800,
  });

  const makePlanCardFadeOut2 = useParallax({
    opacity: [1, 0],
    startScroll: 3600,
    endScroll: 3800,
  });

  const makePlanCardScaleOut = useParallax({
    scale: [1, 10],
    opacity: [1, 0],
    startScroll: 3600,
    endScroll: 3800,
  })

  const makePlanPage = useParallax({
    startScroll: 2900,
    endScroll: 3800,
    onProgressChange: (progress) => {
      const makePlanTitleElement = makePlanTitle.ref.current;
      const makePlanFigureElement = makePlanFigure.ref.current;
      const makePlanCardsElement = makePlanCards.ref.current;
      const makePlanDescriptionElement = makePlanDescription.ref.current;
      if (progress > 0.9) {
        const percent = (progress - 0.90) / (1 - 0.90);
        const opacityValue = ((0 - 1) * percent) + 1;
        makePlanTitleElement.style.opacity = opacityValue;
        makePlanFigureElement.style.opacity = opacityValue;
        makePlanCardsElement.style.opacity = opacityValue;
        makePlanDescriptionElement.style.opacity = opacityValue;
      }
    }
  });

  // Chat section.
  const chatFigure = useParallax({
    opacity: [0, 1],
    startScroll: 3700,
    endScroll: 3800,
  });

  const chatMessageFigure = useParallax({
    opacity: [0, 1],
    translateY: [200, 0],
    startScroll: 3800,
    endScroll: 4000,
  });

  const chatMessageHeart = useParallax({
    opacity: [0, 1],
    startScroll: 3850,
    endScroll: 3950,
  });

  const chatMessageFigure2 = useParallax({
    opacity: [0, 1],
    translateY: [340, 120],
    startScroll: 4000,
    endScroll: 4200,
  });

  const chatMessageFigure3 = useParallax({
    opacity: [0, 1],
    translateY: [580, 320],
    startScroll: 4200,
    endScroll: 4500,
  });

  const chatPage = useParallax({
    startScroll: 3700,
    endScroll: 4600,
    onProgressChange: (progress) => {
      const chatFigureElement = chatFigure.ref.current;

      if (progress > 0.9) {
        const percent = (progress - 0.90) / (1 - 0.90);
        const opacityValue = ((0 - 1) * percent) + 1;
        chatFigureElement.style.opacity = opacityValue;
      }
    }
  });

  const downloadPageTitle = useParallax({
    opacity: [0, 1],
    startScroll: 4600,
    endScroll: 4800,
  });

  const downloadPageLink = useParallax({
    opacity: [0, 1],
    startScroll: 4700,
    endScroll: 4900,
  });

  const downloadPage = useParallax({
    startScroll: 4600,
    endScroll: 5500,
  });

  return {
    pitchSocialLanding,
    introTitleWrapper,
    introTitle,
    introFigure,
    introPage,
    exploreTitle,
    exploreCards,
    exploreDescription,
    explorePage,
    profileTitle,
    profileFigure,
    profileInterest,
    profileDescription,
    profilePage,
    makePlanTitle,
    makePlanFigure,
    makePlanCards,
    makePlanDescription,
    makePlanCardFadeOut1,
    makePlanCardFadeOut2,
    makePlanCardScaleOut,
    makePlanPage,
    chatFigure,
    chatMessageFigure,
    chatMessageHeart,
    chatMessageFigure2,
    chatMessageFigure3,
    chatPage,
    downloadPage,
    downloadPageTitle,
    downloadPageLink
  }
}
